var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagpin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    width: "30px",
    height: "30px",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4343"
    },
    points: "4.8,28.2 4.8,2.8 19,2.8 19.5,5.5 27.3,5.5 27.3,21.4 16,21.4 15.4,18.5 9.5,18.5 9.5,28.2  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M18.1,3.8l0.5,2.7h7.7v13.7h-9.6l-0.5-2.7H8.5v9.6H5.8V3.8L18.1,3.8 M19.8,1.8h-1.6H5.8h-2v2v23.3v2 h2h2.7h2v-2v-7.6h4l0.2,1.1l0.3,1.6h1.6h9.6h2v-2V6.6v-2h-2h-6L20,3.4L19.8,1.8L19.8,1.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 13,
    style: {
      fill: "#FFFFFF"
    },
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 4.9,
    style: {
      fill: "#FFFFFF"
    },
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 9,
    style: {
      fill: "#FFFFFF"
    },
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.6,
    y: 12,
    style: {
      fill: "#FFFFFF"
    },
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 16,
    style: {
      fill: "#FFFFFF"
    },
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 8,
    style: {
      fill: "#FFFFFF"
    },
    width: 3,
    height: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagpin);
export default __webpack_public_path__ + "static/media/flagpin.45f4cc7ba4c38f5f683fb07ca5d92c7c.svg";
export { ForwardRef as ReactComponent };